import apiClient from './apiClient';

const MATERIAL_REQUESTS_PATH = '/material-requests';

export const getMaterialRequests = async () => {
  const response = await apiClient.get(MATERIAL_REQUESTS_PATH);

  return response.data;
};

export const createMaterialRequest = async ({ materialName }) => {
  const response = await apiClient.post(MATERIAL_REQUESTS_PATH, {
    materialName,
  });

  return response.data;
};

export const deleteMaterialRequest = async (requestId) => {
  const response = await apiClient.delete(`${MATERIAL_REQUESTS_PATH}/${requestId}`);

  return response.data;
};
